import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  footer: {
    minHeight: 70,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      position: "relative",
    },
    "& a": {
      textDecoration: "none",
    },
  },
  logoFooter: {
    minHeight: 70,
    "& img": {
      maxHeight: 34,
      maxWidth: 137,
    },
    "& > div": {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      fontSize: "0.6em",
      "& a": {
        fontSize: "1em",
      },
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: theme.spacing(1),
    },
  },
  legalText: {
    textAlign: "right",
    minHeight: 70,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    "& > div": {
      paddingRight: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      marginTop: theme.spacing(1),
      "& > div": {
        paddingLeft: theme.spacing(1),
        fontSize: "0.6em",
        "& a": {
          fontSize: "0.6em",
        },
      },
    },
  },
  copyright: {
    marginBottom: 10,
  },
}));

export default function FooterComponent() {
  const intl = useIntl();
  const classes = useStyles();
  const today = new Date();
  const year = today.getFullYear();
  return (
    <div className={classes.footer}>
      <Grid container>
        <Grid item sm={8} md={8} className={classes.logoFooter}>
          <div>Copyright©[1966 – {year}], Johns Hopkins University. {intl.formatMessage({ id: "footer_allRightsReserved" })}</div>
          <div>{intl.formatMessage({ id: "footer_omimLegalText" })}</div>
          <div>{intl.formatMessage({ id: "footer_omimLegalText2" })} <a href={"http://omim.org/downloads"} target="_blank" rel="noreferrer">
            http://omim.org/downloads
          </a>.</div>
        </Grid>
        <Grid item sm={4} md={4} className={classes.legalText}>
          <div className={classes.copyright}>Copyright © {year} Genomepleio S.L.</div>
          <div>
            {intl.formatMessage({ id: "all_rights_reserved" })}
            <b>
              <a href={"https://genomepleio.com/privacy-policy/"} target="_blank" rel="noreferrer">
                {intl.formatMessage({ id: "privacy_policy" })}
              </a>
            </b>
            <b>
              <a href={"https://genomepleio.com/legal-notice/"} target="_blank" rel="noreferrer">
                {intl.formatMessage({ id: "terms_of_use" })}
              </a>
            </b>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
